import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import PartnerTiers from './components/PartnerTiers';
import APIExplorer from './components/APIExplorer';
import IntegrationMarketplace from './components/IntegrationMarketplace';
import DeveloperResources from './components/DeveloperResources';
import PartnerBenefits from './components/PartnerBenefits';
import PartnerTestimonials from './components/PartnerTestimonials';
import CTASection from './components/CTASection';

const PartnerEcosystem: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Partner Ecosystem - camlytix AI</title>
        <meta 
          name="description" 
          content="Join the camlytix AI partner ecosystem. Build innovative AI analytics solutions with enterprise-grade tools and support." 
        />
        <meta 
          name="keywords" 
          content="API integration, developer portal, SDK, partner program, integration marketplace, technology partners, AI analytics API, developer resources" 
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* <HeroSection /> */}
          {/* <PartnerTiers /> */}
          {/* <APIExplorer /> */}
          {/* <IntegrationMarketplace /> */}
          {/* <DeveloperResources /> */}
          {/* <PartnerBenefits /> */}
          {/* <PartnerTestimonials /> */}
          <CTASection />
        </main>

        {/* <footer className="bg-authority-charcoal text-black py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
              <div>
                <h3 className="text-lg font-semibold mb-4">Partner Resources</h3>
                <ul className="space-y-2 text-sm text-gray-600/80">
                  <li><a href="/partner-portal" className="hover:text-gray-600 transition-colors">Partner Portal</a></li>
                  <li><a href="/api-docs" className="hover:text-gray-600 transition-colors">API Documentation</a></li>
                  <li><a href="/sdk-downloads" className="hover:text-gray-600 transition-colors">SDK Downloads</a></li>
                  <li><a href="/integration-guides" className="hover:text-gray-600 transition-colors">Integration Guides</a></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Support</h3>
                <ul className="space-y-2 text-sm text-gray-600/80">
                  <li><a href="/developer-support" className="hover:text-gray-600 transition-colors">Developer Support</a></li>
                  <li><a href="/community-forum" className="hover:text-gray-600 transition-colors">Community Forum</a></li>
                  <li><a href="/status" className="hover:text-gray-600 transition-colors">API Status</a></li>
                  <li><a href="/changelog" className="hover:text-gray-600 transition-colors">Changelog</a></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Programs</h3>
                <ul className="space-y-2 text-sm text-gray-600/80">
                  <li><a href="/partner-tiers" className="hover:text-gray-600 transition-colors">Partnership Tiers</a></li>
                  <li><a href="/certification" className="hover:text-gray-600 transition-colors">Certification Program</a></li>
                  <li><a href="/co-marketing" className="hover:text-gray-600 transition-colors">Co-Marketing</a></li>
                  <li><a href="/referral-program" className="hover:text-gray-600 transition-colors">Referral Program</a></li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-4">Company</h3>
                <ul className="space-y-2 text-sm text-gray-600/80">
                  <li><a href="/about" className="hover:text-gray-600 transition-colors">About Us</a></li>
                  <li><a href="/contact" className="hover:text-gray-600 transition-colors">Contact</a></li>
                  <li><a href="/privacy" className="hover:text-gray-600 transition-colors">Privacy Policy</a></li>
                  <li><a href="/terms" className="hover:text-gray-600 transition-colors">Terms of Service</a></li>
                </ul>
              </div>
            </div>
            <div className="border-t border-white/10 pt-8 text-center text-sm text-gray-600/60">
              <p>&copy; {new Date().getFullYear()} camlytix AI. All rights reserved.</p>
            </div>
          </div>
        </footer> */}
      </div>
    </>
  );
};

export default PartnerEcosystem;